import {createContext, useContext} from "react";

// Create a context for the uniforms
export const UniformsContext = createContext<any>(null);

export const useUniforms = () => {
  const context = useContext(UniformsContext);
  if (!context) {
    throw new Error("useUniforms must be used within a UniformsProvider");
  }
  return context;
};
